import React from "react";
import { Navigate } from "react-router-dom";
import App from "./../app.jsx";

import Error from "./../pages/error/error.js";
import Login from "./../pages/user/login.js";
import Register from "./../pages/user/register.js";
import TermsOfUse from "../pages/user/term.js";
import PrivacyPolicy from "../pages/user/privacy.js";
import PrivateRoute from "../config/privateRoute.js";

import Home from "./../pages/home/home.js";
import TercerosTable from "./../pages/terceros/tercerosTable.js";
import TerceroInfo from "./../pages/terceros/terceroInfo.js";
import RegistrarComprobante from "../pages/ventas/RegistrarComprobante.js";
import ComprobantesEmitidos from "../pages/ventas/ComprobantesEmitidos.js";
import PagosRecibidos from "../pages/ventas/PagosRecibidos.js";

import Comprobante from "../pages/ventas/Comprobante.js";
import Company from "../pages/company/Company.js";
import Pago from "../pages/ventas/Pago.js";
import InvalidacionesEmitidas from "../pages/ventas/InvalidacionesEmitidas.js";

import ContingenciaTable from "../pages/contingencia/ContingenciaTable.js";
import ContingenciaInfo from "../pages/contingencia/ContingenciaInfo.js";

import ComprasTable from "../pages/compras/ComprasTable.js";

import ConfirmarCuenta from "../pages/user/confirmar-cuenta.js";
import CuentaConfirmada from "../pages/user/cuenta-confirmada.js";
import ErrorConfirmacion from "../pages/user/error-confirmacion.js";

const AppRoute = [
  { path: "/login", element: <Login /> },
  { path: "/register", element: <Register /> },
  { path: "/terms", element: <TermsOfUse /> },
  { path: "/privacy", element: <PrivacyPolicy /> },
  { path: "/confirmar-cuenta", element: <ConfirmarCuenta /> },
  { path: "/cuenta-confirmada", element: <CuentaConfirmada /> },
  { path: "/error-confirmacion", element: <ErrorConfirmacion /> },

  {
    path: "/",
    element: <PrivateRoute />, // ✅ Protege todo lo que está dentro de App
    children: [
      {
        path: "/",
        element: <App />,
        children: [
          { path: "", element: <Home /> },
          { path: "dashboard", element: <Home /> }, // Dashboard

          // Rutas de menu Terceros - Clientes/Proveedores
          { path: "terceros", element: <TercerosTable /> },
          { path: "tercero", element: <TerceroInfo /> },
          { path: "tercero/:id", element: <TerceroInfo /> },

          // Rutas de menu Ventas
          {
            path: "venta/registrar_comprobante",
            element: <RegistrarComprobante />,
          },
          { path: "venta/comprobantes_emitidos", element: <ComprobantesEmitidos solo_notas_emitidas={false} /> },
          { path: "venta/notas_emitidas", element: <ComprobantesEmitidos solo_notas_emitidas={true} /> },

          { path: "venta/comprobante/:comprobante_id", element: <Comprobante /> },
          { path: "venta/registro_pagos", element: <PagosRecibidos /> },
          { path: "venta/pago", element: <Pago /> },
          { path: "venta/invalidaciones", element: <InvalidacionesEmitidas /> },

          { path: "compras/comprobantes_proveedores", element: <ComprasTable /> },

          { path: "company", element: <Company /> },

          { path: "eventos_contingencia", exact: true, title: "Evento de Contingencia", element: <ContingenciaTable /> },
          { path: "contingencia/:evento_contingencia_id", element: <ContingenciaInfo /> },

          { path: "*", element: <Error /> }, // Página de error
        ],
      },
    ],
  },

  { path: "*", element: <Navigate to="/login" /> },
];

export default AppRoute;
